import CancelPallet from "./CancelPallet";
import {IoIosCloseCircle} from "react-icons/io";
import React from "react";

const DrawerColumn = (showEvent=true) => {


    const columns = [
        {
            className: 'hidden',
            title: 'ردیف', dataIndex: 'row', key: 'row', render: (text, row, index) => {
                return index + 1;
            },
        },

        {
            title: ' شناسه پالت',

            dataIndex: 'palletId',
            key: 'palletId',
        }, {
            title: 'محصول',
            dataIndex: 'product',
            key: 'product',
        },
        {


            title: ' برند',
            dataIndex: 'brand',
            key: 'brand',
        }, {
            title: 'خط تولید',
            dataIndex: 'productLine',
            key: 'productLine',


        }, {
            title: 'واحد',
            dataIndex: 'branch',
            key: 'branch',
        },


        {
            title: ' تعداد در پالت',
            dataIndex: 'numberPerPallet',
            key: 'numberPerPallet'
        }, {
            title: 'ق.ت',
            dataIndex: 'manufacturerPriceRials',
            key: 'manufacturerPriceRials',
        }, {
            title: ' ق.م',
            dataIndex: 'consumerPriceRials',
            key: 'consumerPriceRials',
        },

        {
            title: '  تاریخ تولید',
            dataIndex: 'dateOfManufacture',
            key: 'dateOfManufacture',
        }, {
            title: 'تاریخ انقضا',
            dataIndex: 'expireDate',
            key: 'expireDate',
        }, {
            title: 'بچ',
            dataIndex: 'batchNumber',
            key: 'batchNumber',
        }, {
            title: ' کارشناس QC',
            dataIndex: 'qualityControlSupervisor',
            key: 'qualityControlSupervisor',

        }, {
            title: 'سرپرست تولید',
            dataIndex: 'seriCreateBy',
            key: 'seriCreateBy',
        },{
            title: 'درخواست ',
            dataIndex: 'cancleRequest',
            key: 'cancleRequest',
            render:(item)=>{
                return <span>{item && <IoIosCloseCircle color='red' size={30}/>}</span>
            }
        },

        { fixed: 'right',className: `cell-fix-left ${!showEvent && 'hidden' }`,
            title: 'عملیات',
            dataIndex: 'events',
            key: 'events',
            render: (x, row) => {
                return  <CancelPallet rowData={row} />


            }
        }


    ];
    return [columns];
};

export default DrawerColumn;